import { featuredPicks } from "@/mocks/featuredData";
import { toneIconClass, toneBadgeClass } from "./tones";

export default function EditorPicks() {
  return (
    <section id="picks" className="scroll-mt-20">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="mx-auto max-w-shell">
          <div className="max-w-2xl">
            <span className="text-sm text-primary-700 font-label">编辑精选</span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
              这几站，我们自己也常开
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              从收录列表里挑出最近回访最多的一批，附上一句实话实说的推荐理由，先看这几个不容易踩坑。
            </p>
          </div>

          <div className="mt-9 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-5">
            {featuredPicks.map((pick) => (
              <article
                key={pick.name}
                className="flex flex-col p-5 rounded-lg bg-background-50 border border-background-200"
              >
                <div className="flex items-center gap-3">
                  <span
                    className={`w-11 h-11 rounded-lg border flex items-center justify-center ${toneIconClass[pick.tone]}`}
                  >
                    <i className={`${pick.icon} text-xl`}></i>
                  </span>
                  <div className="min-w-0">
                    <h3 className="font-heading text-base font-semibold text-foreground-950 truncate">
                      {pick.name}
                    </h3>
                    <span
                      className={`mt-1 inline-block px-2 py-0.5 rounded-full border text-[11px] ${toneBadgeClass[pick.tone]}`}
                    >
                      {pick.category}
                    </span>
                  </div>
                </div>
                <p className="mt-4 text-sm text-foreground-600 leading-relaxed flex-1">
                  {pick.summary}
                </p>
                <p className="mt-4 pl-3 border-l-2 border-accent-400 text-xs text-foreground-700 leading-relaxed">
                  {pick.reason}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}